import { render, staticRenderFns } from "./admin_submit_cider.vue?vue&type=template&id=6ba8bfbd&scoped=true"
import script from "./admin_submit_cider.vue?vue&type=script&lang=js"
export * from "./admin_submit_cider.vue?vue&type=script&lang=js"
import style0 from "./admin_submit_cider.vue?vue&type=style&index=0&id=6ba8bfbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba8bfbd",
  null
  
)

export default component.exports